import React from 'react';

import poster from '../images/event_poster.jpg'

const CampaignPreview = ({
  type,
  name,
  preview,
  stats,
}) => {
  const classname = type ? ` camp--${type}` : '';
  return (
    <div className={'camp' + classname}>
      <div className="camp__preview">
        <img className="camp__img" src={ preview || poster } alt=""/>
      </div>
      <div className="camp__descr">
        {/* { name && <div className="camp__title">{name}</div> } */}
        { type && <div className="camp__type">{ type }</div> }
        <div className="camp__stats">
          <div className="camp__stat">
            <div className="camp__digit">{ stats.impressions }</div>
            <div className="camp__label">Impr</div>
          </div>
          <div className="camp__stat">
            <div className="camp__digit">{ stats.openrate }%</div>
            <div className="camp__label">Open</div>
          </div>
          <div className="camp__stat">
            <div className="camp__digit">{ stats.clickrate }%</div>
            <div className="camp__label">Click</div>
          </div>
          <div className="camp__stat">
            <div className="camp__digit">{ Math.round(stats.impressions / stats.clickrate) }</div>
            <div className="camp__label">CTA</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CampaignPreview


// WEBPACK FOOTER //
// ./src/components/CampaignPreview.js